<template>
  <el-menu
    :default-active="active"
    text-color="#ffffff"
    :router="true"
    unique-opened
  >
    <template v-for="(item,index) in menuList">
      <el-submenu
        v-if="item.childNode && item.childNode.length > 0"
        :index="String(index)"
        :key="index"
        class="c-menu"
      >
        <template slot="title">
          <i class="iconfont" :class="item.iconPath"></i>
          <span slot="title">{{item.menuName}}</span>
        </template>
        <el-menu-item
          v-for="(cItem, cIndex) in item.childNode"
          :index="cItem.url"
          :key="cIndex"
        ><div>{{ cItem.menuName }}</div></el-menu-item>
      </el-submenu>
      <el-menu-item
        v-else
        :index="item.url"
        :key="index"
        class="f-menu"
      >
        <i class="iconfont" :class="item.iconPath"></i>
        <span slot="title">{{ item.menuName }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
export default {
  name: 'LeftMenu',
  data () {
    return {
      menuList: []
    }
  },
  computed: {
    active () {
      const list = ['patrol', 'laborManageList', 'property']
      const path = this.$route.path.split('/')
      let active = '/' + path[1]
      if (path[1] && path[2] && list.includes(path[1])) {
        active += '/' + path[2]
      }
      return active
    },
    menus () {
      return this.$store.state.menuList
    }
  },
  watch: {
  },
  created () {
    const index = this.menus.findIndex(item => item.menuName === '设置菜单')
    this.menuList = this.menus[index].childNode || []
    // this.getButtonList(this.menuList)
    // 初次进入页面
    if (this.menuList.length > 0 && this.$route.path === '/setting') {
      this.$router.push(this.menuList[0].url)
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
  .el-menu{
    border: 0 !important;
    background: transparent !important;
    .iconfont {
      color: #c5dcee;
      padding: 0 10px;
    }
    ::v-deep {
      .el-menu-item,.el-submenu .el-submenu__title {
        height: 40px;
        line-height: 40px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
      }
      .el-submenu__title{
        padding-left: 0px !important;
      }
      .el-icon-arrow-down:before {
        content: "\e6df";
        color: rgba(255, 255, 255, 0.69);
      }
    }
  }
  .f-menu {
    height: 40px;
    line-height: 40px;
    padding: 0 !important;
    border-top: 1px solid #2558a6;
    background: #0D447E;
    border-radius: 0;
    &.is-active {
      color: #ffffff !important;
      background: #007bff !important;
    }
    &:hover {
      background: #007bff;
    }
  }
  .c-menu {
    border-top: 1px solid #2558a6;
    background: #0D447E !important;
    ::v-deep {
      .el-submenu__title:hover {
        background: #007bff;
      }
      .el-menu {
        background: #2558a6;
        padding: 8px !important;
        li{
          min-width: 100px;
          height: 34px;
          line-height: 34px;
          border-radius: 4px;
          padding-left: 15px !important;
          &:hover, &.is-active {
            color: #007EFF !important;
            background: linear-gradient(62deg, #C6E4FF, #DEDCFB) !important;
          }
        }
      }
    }
  }
</style>
